/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendUserTyping} from '../api'

export const useMutationSendUserTyping = createReactQueryMutationHook('sendUserTyping', sendUserTyping)
